import React from 'react';
import ReactGA from 'react-ga4';

// Initialize Google Analytics 4
ReactGA.initialize('G-VPBXHM5KK9');
import { createRoot } from 'react-dom/client';

import App from './App';
import { HelmetProvider } from 'react-helmet-async';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
	<HelmetProvider>
		<App />
	</HelmetProvider>
);

// Register service worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(registration => {
        console.log('Service Worker registered with scope:', registration.scope);
      })
      .catch(error => {
        console.error('Service Worker registration failed:', error);
      });
  });
}
